import { useEffect } from 'react';
import { useTheme } from 'src/provider/ThemeProvider';
import PageContentWrapper from 'src/components/PageContentWrapper/PageContentWrapper';
import { CurrentSubscriptionPlansSection } from './CurrentSubscriptionPlansSection/CurrentSubscriptionPlansSection';
import { PaymentHistorySection } from './PaymentHistorySection/PaymentHistorySection';
import { PaymentMethodCard } from './PaymentMethod/PaymentMethodCard';
import { PaymentDetailsCard } from './PaymentDetails/PaymentDetailsCard';
import { setIsCompanyChanged } from 'src/store/slices/companySlice';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { SUBSCRIPTION_ACCESS_ROLES } from 'src/constants/roles';
import { useNavigate } from 'react-router-dom';
import { PATH_HOME } from 'src/constants/spa-routes';
import { EmailForInvoiceCard } from 'src/pages/SubscriptionPage/EmailForInvoice/EmailForInvoiceCard';
import { useAppDispatch } from 'src/store';

const SubscriptionPage = () => {
  const dispatch = useAppDispatch();
  const { setTheme } = useTheme();
  const navigate = useNavigate();

  const { data: userInfo } = useGetUsersMeQuery();

  useEffect(() => {
    setTheme('green');
    dispatch(setIsCompanyChanged(false));
  }, []);

  useEffect(() => {
    if (userInfo && !SUBSCRIPTION_ACCESS_ROLES.includes(userInfo?.role)) {
      navigate(PATH_HOME.ROOT);
    }
  }, [userInfo]);

  return (
    SUBSCRIPTION_ACCESS_ROLES.includes(userInfo?.role) && (
      <PageContentWrapper className={'project-page-container'}>
        <CurrentSubscriptionPlansSection />
        <div className={'flex md:flex-row flex-col gap-0.625-rem'}>
          <PaymentDetailsCard />
          <PaymentMethodCard />
          <EmailForInvoiceCard />
        </div>
        <PaymentHistorySection />
      </PageContentWrapper>
    )
  );
};

export default SubscriptionPage;
